<template>
  <div>
    <div v-if="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
    </div>
    <form @submit.prevent>
      <div class="row">
        <div class="col-12">
          <fg-input type="text"
            placeholder="Full Name"
            :class="{ 'form-group--error': $v.name.$error }"
            v-model="$v.name.$model">
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
          <textarea placeholder="Description"
            class="form-control"
            v-model="description" />
          </div>
        </div>
      </div>
      <div class="text-left">
        <p-button type="info"
          :loading="isCreatingGroup"
          @click.native.prevent="createGroup">
          Create
        </p-button>
      </div>
      <div class="clearfix"></div>
    </form>
  </div>
</template>

<script>
import { notify } from '../../services/notify';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'NewGroupForm',
  props: {
    parent: Object
  },
  data() {
    return {
      name: "",
      description: "",
      isCreatingGroup: false,
      successMessage: ""
    }
  },
  validations: {
    name: { required }
  },
  methods: {
    async createGroup() {
      this.successMessage = "";

      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error('Please provide a name and description for the new group.')
        return;
      }

      this.isCreatingGroup = true;
      const success = await this.$store.dispatch('group/createGroup', {
        name: this.name,
        description: this.description,
        parent_id: this.parent.id,
        organization_id: this.parent.organization_id
      });
      this.isCreatingGroup = false;

      if (success) {
        this.successMessage = `Success! Created new group ${this.name}.`;
        this.$emit('hasUpdate');
        this.resetForm();
      }
    },
    resetForm() {
      this.name = "";
      this.description = "";
      this.$v.$reset();
    }
  }
};
</script>
